import React from 'react';

export const NoDataMessage = () => (
  <div className="flex gap-1 items-center p-8 text-3xl text-neutral-500">
    No data available
  </div>
);

export default NoDataMessage;